import React, { useMemo } from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import { ExdEmpty } from "../../ExDashboard/components/exdMui";
import { MD, mdScrollbarSx } from "./mdTheme";
import { MdWidgetCard, MdPeriodSelect } from "./MdCardShell";
import MdClientRankRow from "./MdClientRankRow";
import { MdMoneyValue } from "./MdMoneyValue";

const MdRankListCard = ({
  eyebrow,
  title,
  crumb,
  infoTitle,
  loading,
  rows = [],
  periodValue,
  onPeriodChange,
  periodOptions,
  periodFallback = "ALL",
  formatValue,
  money = false,
  currency,
  maxHeight = 300,
  emptyLabel,
}) => {
  const normalized = useMemo(
    () =>
      (rows || [])
        .map((row, index) => ({
          key: row.key || row.id || `${row.label || row.name}-${index}`,
          label: row.label || row.name || `Item ${index + 1}`,
          value: Number(row.value ?? row.y ?? 0) || 0,
          barPct:
            Number(
              row.barPct ??
                row.salesPercentage ??
                row.countPercentage ??
                row.usedCountPercentage ??
                0,
            ) || 0,
          raw: row.raw ?? row,
          onClick: row.onClick,
        }))
        .filter((r) => r.label),
    [rows],
  );

  const maxValue = useMemo(
    () => Math.max(...normalized.map((r) => r.value), 0),
    [normalized],
  );

  return (
    <MdWidgetCard
      loading={loading}
      eyebrow={eyebrow}
      title={title}
      crumb={crumb}
      infoTitle={infoTitle}
      sx={{ overflow: "hidden", minWidth: 0 }}
      controls={
        onPeriodChange ? (
          <MdPeriodSelect
            value={periodValue}
            onChange={onPeriodChange}
            options={periodOptions}
            fallbackLabel={periodFallback}
          />
        ) : null
      }
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 0.625,
          maxHeight,
          minWidth: 0,
          overflowX: "hidden",
          overflowY: "auto",
          pr: 0.25,
          width: "100%",
          ...mdScrollbarSx,
        }}
      >
        {normalized.length ? (
          normalized.map((row, index) => {
            const barPct =
              row.barPct || (maxValue ? (row.value / maxValue) * 100 : 0);
            const display =
              typeof formatValue === "function" ? (
                formatValue(row.value, row.raw)
              ) : money ? (
                <MdMoneyValue
                  amount={row.value}
                  currency={currency}
                  fontSize={12}
                  fontWeight={600}
                  showTooltip={false}
                  sx={{ justifyContent: "flex-end" }}
                />
              ) : (
                Number(row.value).toLocaleString()
              );
            const color = MD.chart[index % MD.chart.length];
            return (
              <Tooltip
                key={row.key}
                title={
                  <Typography sx={{ fontSize: 13 }}>
                    <strong>{row.label}</strong>
                    <Box>{Number(row.value).toLocaleString()}</Box>
                  </Typography>
                }
                placement="top"
                enterDelay={250}
              >
                <Box sx={{ minWidth: 0, width: "100%" }}>
                  <MdClientRankRow
                    label={row.label}
                    value={display}
                    barPct={barPct}
                    color={color}
                    onClick={row.onClick}
                    wideValue={money}
                  />
                </Box>
              </Tooltip>
            );
          })
        ) : (
          <ExdEmpty>{emptyLabel}</ExdEmpty>
        )}
      </Box>
    </MdWidgetCard>
  );
};

export default MdRankListCard;
